<app-loader *ngIf="isDisabled"></app-loader>
<div class="card" style="min-height: 100%;">
    <div class="card-header">
        <div class="row">
            <div class="col">
                Tax Declaration {{GetID == 1?'Approval':'Request'}}
            </div>
            <div class="col-auto" *ngIf="this.Filter.IsDraft">
                <span class="badge view">Draft</span>
            </div>
            <div class="col-auto">
                <span class="badge"
                    [ngClass]="{'success': common.ToLowerCase(DetailData.Table[0].ApprovalStatus) == 'approved', 'danger':common.ToLowerCase(DetailData.Table[0].ApprovalStatus) == 'rejected','warning':common.ToLowerCase(DetailData.Table[0].ApprovalStatus) == 'pending' || common.ToLowerCase(DetailData.Table[0].ApprovalStatus) == 'reInitiated' || common.ToLowerCase(DetailData.Table[0].ApprovalStatus) == 'pendingwithsenior'}">{{DetailData.Table[0].ApprovalStatus}}</span>
            </div>
        </div>
    </div>
    <div class="card-body p-0">
        <div class="row g-0">
            <div class="col-md-12">
                <div class="card">
                    <div class="card-body p-1">
                        <div class="row">
                            <div class="col-md-6">
                                <div class="row" style="align-items: center;line-height: normal;">
                                    <div class="col-2">
                                        <img *ngIf="DetailData.Table[0].Photo != null && DetailData.Table[0].Photo != ''"
                                            mat-card-image class="userImage"
                                            [src]="common.PhotoLink(DetailData.Table[0].Photo)" />
                                        <div *ngIf="DetailData.Table[0].Photo == null || DetailData.Table[0].Photo == ''"
                                            class="initial-image">
                                            <div class="image">
                                                {{common.getInitial(DetailData.Table[0].EmpName)}}
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-9 userdetail">
                                        <label class="form-label"
                                            style="font-size: 13px!important;font-weight: 500; margin-bottom: 0;color: #191d4a;">{{DetailData.Table[0].EmpName}}</label><br />
                                        <label class="form-label"
                                            style="font-size: 10px!important;font-weight: 500; margin-bottom: 0;color: #aaaab2;">#{{DetailData.Table[0].EmpCode}}</label><br />
                                    </div>
                                </div>
                            </div>
                            <div class="col"></div>
                        </div>
                        <div style="background-color:#0078d42e;border-radius: 5px;" class="p-2 mb-2">
                            <div class="row">
                                <div class="col-md-5">
                                    <label for="FromDate" class="text-label-light">Financial Year Start</label> <br />
                                    <label name="FromDate"
                                        class="text-label-dark">{{DetailData.Table[0].FinancialYearStart}}</label>
                                </div>
                                <div class="col-md-5">
                                    <label for="ToDate" class="text-label-light">Financial Year End</label> <br />
                                    <label name="ToDate" class="text-label-dark">{{DetailData.Table[0].FinancialYearEnd
                                        | date :'dd MMM yyyy'}}</label>
                                </div>
                                <div class="col-md-2">
                                    <label for="NoOfDays" class="text-label-light">Regime</label> <br />
                                    <label name="NoOfDays"
                                        class="text-label-dark">{{DetailData.Table[0].IsNewRegime?'New':'Old'}}</label>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <!-- <div class="col-md-5 ps-1">
                <div class="container">
                    <div class="row">
                        <div class="col-md-12 p-0">
                            <div class="card">
                                <label class="m-2" *ngIf="!isApprovalLavel">{{tooltip.NoApprovalLevel}}</label>
                                <div class="card-body" *ngIf="isApprovalLavel">
                                    <div id="content">
                                        <ul class="timeline">
                                            <li class="event p-0 m-0" *ngFor="let Tracking of TrackingsUser">
                                                <div class="row align-items-center">
                                                    <div class="col-2">
                                                        <img *ngIf="Tracking['Photo'] != null && Tracking['Photo'] != ''"
                                                            mat-card-image class="userImage"
                                                            [src]="common.PhotoLink(Tracking['Photo'])" />
                                                        <div *ngIf="Tracking['Photo'] == null || Tracking['Photo'] == ''"
                                                            class="initial-image">
                                                            <div class="image">
                                                                {{common.getInitial(Tracking['ApproverName'])}}
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div class="col">
                                                        <h3 class="m-0">
                                                            {{Tracking['ApproverName']}}({{Tracking['ApprovalStage']}})
                                                        </h3>
                                                    </div>
                                                    <div class="col-auto"><span class="badge"
                                                            [ngClass]="{'success': (common.ToLowerCase(Tracking['Status']) == 'approved' || common.ToLowerCase(Tracking['Status']) == 'autoapproved'), 'danger':common.ToLowerCase(Tracking['Status']) == 'rejected','warning':common.ToLowerCase(Tracking['Status']) == 'pending' || common.ToLowerCase(Tracking['Status']) == 'reInitiated'}">{{Tracking['Status']}}</span>
                                                    </div>
                                                </div>
                                                <label class="date">{{Tracking['ActionDate']}}</label>
                                                <p class="remark">{{Tracking['Remark']}}</p>
                                                <input type="text" class="form-control" placeholder="Remark" id="Remark"
                                                    name="LocalCity" [(ngModel)]="Filter.Remark" #Remark="ngModel"
                                                    *ngIf="common.ToLowerCase(DetailData.Table[0].ApprovalStatus) == 'pending' && common.ToLowerCase(Tracking['Status']) == 'pending' && GetID == 1">
                                                <hr />
                                            </li>
                                            <li class="event p-0 m-0" *ngFor="let Tracking of Trackings">
                                                <div class="row align-items-center">
                                                    <div class="col-2">
                                                        <img *ngIf="Tracking['Photo'] != null && Tracking['Photo'] != ''"
                                                            mat-card-image class="userImage"
                                                            [src]="common.PhotoLink(Tracking['Photo'])" />
                                                        <div *ngIf="Tracking['Photo'] == null || Tracking['Photo'] == ''"
                                                            class="initial-image">
                                                            <div class="image">
                                                                {{common.getInitial(Tracking['ApproverName'])}}
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div class="col">
                                                        <h3>{{Tracking['ApproverName']}}({{Tracking['ApprovalStage']}})
                                                        </h3>
                                                    </div>
                                                    <div class="col-auto"><span class="badge"
                                                            [ngClass]="{'success': (common.ToLowerCase(Tracking['Status']) == 'approved' || common.ToLowerCase(Tracking['Status']) == 'autoapproved'), 'danger':common.ToLowerCase(Tracking['Status']) == 'rejected','warning':common.ToLowerCase(Tracking['Status']) == 'pending' || common.ToLowerCase(Tracking['Status']) == 'reInitiated'}">{{Tracking['Status']}}</span>
                                                    </div>
                                                </div>
                                                <label class="date">{{Tracking['ActionDate']}}</label>
                                                <p class="remark">{{Tracking['Remark']}}</p>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div> -->
        </div>
        <div class="row g-0">
            <div class="card my-1">
                <div class="card-header">
                    <div class="row">
                        <div class="col">
                            <span class="custome-header">
                                <i class="bi bi-briefcase px-2"></i>Previous Employment Details
                            </span>
                        </div>
                        <div class="col-auto mx-2 align-self-center" style="display: inline-flex;">
                            <span class="px-1"
                                style="font-size: 0.9rem;">{{this.OpenCard.CardPreviousEmployment?'Yes':'No'}}</span>
                            <div class="form-check form-switch">
                                <input class="form-check-input" type="checkbox" role="switch"
                                    [checked]="OpenCard.CardPreviousEmployment" id="flexSwitchCheckChecked"
                                    (change)="onSwitchChange($event,'CardPreviousEmployment')">
                            </div>
                        </div>
                    </div>
                </div>
                <div>
                    <div #collapse="ngbCollapse" [(ngbCollapse)]="!OpenCard.CardPreviousEmployment">
                        <div class="card-body">
                            <div class="card-body p-0 px-2">
                                <div class="row">
                                    <div class="col p-0">
                                        <div class="table-container">
                                            <table class="customeDatatable table table-bordered">
                                                <thead class="table-light">
                                                    <tr>
                                                        <!-- <th class="sticky-col">Month</th>
                                                    <th class="sticky-col">Year</th> -->
                                                        <th>Remark</th>
                                                        <th>Basic</th>
                                                        <th>DA</th>
                                                        <th>HRA</th>
                                                        <th>Allowance</th>
                                                        <th>Gross</th>
                                                        <th>PT</th>
                                                        <th>PF</th>
                                                        <th>TDS</th>
                                                        <th>Deduction</th>
                                                        <th>Net</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    <tr *ngFor="let element of DetailData.Table2; let i = index">
                                                        <!-- <td class="sticky-col">{{element.Monthname}}</td>
                                                    <td class="sticky-col text-end">{{element.Yearname}}</td> -->
                                                        <td class="text-end">{{element.Remarks}}</td>
                                                        <td class="text-end">{{element.Basic}}</td>
                                                        <td class="text-end">{{element.DA}}</td>
                                                        <td class="text-end">{{element.HRA}}</td>
                                                        <td class="text-end">{{element.OtherAllowance}}</td>
                                                        <td class="text-end">{{element.GrossAmount}}</td>
                                                        <td class="text-end">{{element.PT}}</td>
                                                        <td class="text-end">{{element.PF}}</td>
                                                        <td class="text-end">{{element.TDS}}</td>
                                                        <td class="text-end">{{element.OtherDeduction}}</td>
                                                        <td class="text-end">{{element.NetAmount}}</td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="card my-1">
                <div class="card-header">
                    <div class="row">
                        <div class="col">
                            <span class="custome-header">
                                <i class="bi bi-card-checklist px-2"></i>Chapter VI A Details
                            </span>
                        </div>
                        <div class="col-auto mx-2 align-self-center" style="display: inline-flex;">
                            <span class="px-1"
                                style="font-size: 0.9rem;">{{this.OpenCard.CardEmpTaxDeclarationDetails?'Yes':'No'}}</span>
                            <div class="form-check form-switch">
                                <input class="form-check-input" type="checkbox" role="switch"
                                    [checked]="OpenCard.CardEmpTaxDeclarationDetails" id="flexSwitchCheckChecked"
                                    (change)="onSwitchChange($event,'CardEmpTaxDeclarationDetails')">
                            </div>
                        </div>
                    </div>
                </div>
                <div>
                    <div #collapse="ngbCollapse" [(ngbCollapse)]="!OpenCard.CardEmpTaxDeclarationDetails">
                        <div class="card-body">
                            <div class="card-body p-0 px-2">
                                <div class="row">
                                    <div class="col p-0">
                                        <div class="table-container">
                                            <table class="customeDatatable table table-bordered">
                                                <thead class="table-light">
                                                    <tr>
                                                        <th>Section Code</th>
                                                        <th>Section</th>
                                                        <th>IncomeHead</th>
                                                        <th>Sub Section</th>
                                                        <th>Limit Applicable</th>
                                                        <th>Max Limit</th>
                                                        <th>Declared Amount</th>
                                                        <th>Approved Amount</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    <tr *ngFor="let element of DetailData.Table1; let i = index">
                                                        <td>{{element.SectionCode}}</td>
                                                        <td>{{element.SectionName}}</td>
                                                        <td>{{element.IncomeHead}}</td>
                                                        <td>{{element.SubSectionName}}</td>
                                                        <td>{{DetailData.Table[0].IsNewRegime?element.IsNewMaxlimitapplicable:element.IsOldMaxlimitapplicable}}
                                                        </td>
                                                        <td class="text-end">
                                                            {{DetailData.Table[0].IsNewRegime?element.NewRegimeMaxAmount:element.OldRegimeMaxAmount}}
                                                        </td>
                                                        <td class="text-end">{{element.DeclaredAmount}}</td>
                                                        <td class="text-end">
                                                            {{common.ToLowerCase(DetailData.Table[0].ApprovalStatus) ==
                                                            'approved'?element.ApprovedAmount:''}}</td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="card my-1">
                <div class="card-header">
                    <div class="row">
                        <div class="col">
                            <span class="custome-header">
                                <i class="bi bi-house px-2"></i>Are you staying in a rented house?
                            </span>
                        </div>
                        <div class="col-auto mx-2 align-self-center" style="display: inline-flex;">
                            <span class="px-1"
                                style="font-size: 0.9rem;">{{this.OpenCard.CardEmpTaxDeclarationDetails_HRA?'Yes':'No'}}</span>
                            <div class="form-check form-switch">
                                <input class="form-check-input" type="checkbox" role="switch"
                                    [checked]="OpenCard.CardEmpTaxDeclarationDetails_HRA" id="flexSwitchCheckChecked"
                                    (change)="onSwitchChange($event,'CardEmpTaxDeclarationDetails_HRA')">
                            </div>
                        </div>
                    </div>
                </div>
                <div>
                    <div #collapse="ngbCollapse" [(ngbCollapse)]="!OpenCard.CardEmpTaxDeclarationDetails_HRA">
                        <div class="card-body">
                            <div class="card-body p-0 px-2">
                                <div class="row">
                                    <div class="col p-0">
                                        <div class="table-container">
                                            <table class="customeDatatable table table-bordered">
                                                <thead class="table-light">
                                                    <tr>
                                                        <th>FromDate</th>
                                                        <th>ToDate</th>
                                                        <th>Name Of Landloard</th>
                                                        <th>Land LordPanNo</th>
                                                        <th>Address</th>
                                                        <th>IsMetroCity</th>
                                                        <th>DeclaredAmount</th>
                                                        <th>ApprovedAmount</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    <tr *ngFor="let element of DetailData.Table3; let i = index">
                                                        <td>{{element.FromDate}}</td>
                                                        <td>{{element.ToDate}}</td>
                                                        <td>{{element.NameOfLandlord}}</td>
                                                        <td>{{element.LandLordPanNo}}</td>
                                                        <td>{{element.Address}}</td>
                                                        <td>{{element.IsMetroCity?'Yes':'No'}}</td>
                                                        <td class="text-end">{{element.DeclaredAmount}}</td>
                                                        <td class="text-end">
                                                            {{common.ToLowerCase(DetailData.Table[0].ApprovalStatus) ==
                                                            'approved'?element.ApprovedAmount:''}}</td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="card my-1">
                <div class="card-header">
                    <div class="row">
                        <div class="col">
                            <span class="custome-header">
                                <i class="bi bi-cash-stack px-2"></i>Are you receiving rental income from Let out
                                Property?
                            </span>
                        </div>
                        <div class="col-auto mx-2 align-self-center" style="display: inline-flex;">
                            <span class="px-1"
                                style="font-size: 0.9rem;">{{this.OpenCard.CardEmpTaxDeclarationDetails_LOP?'Yes':'No'}}</span>
                            <div class="form-check form-switch">
                                <input class="form-check-input" type="checkbox" role="switch"
                                    [checked]="OpenCard.CardEmpTaxDeclarationDetails_LOP" id="flexSwitchCheckChecked"
                                    (change)="onSwitchChange($event,'CardEmpTaxDeclarationDetails_LOP')">
                            </div>
                        </div>
                    </div>
                </div>
                <div>
                    <div #collapse="ngbCollapse" [(ngbCollapse)]="!OpenCard.CardEmpTaxDeclarationDetails_LOP">
                        <div class="card-body">
                            <div class="card-body p-0 px-2">
                                <div class="row">
                                    <div class="col p-0">
                                        <div class="table-container">
                                            <table class="customeDatatable table table-bordered">
                                                <thead class="table-light">
                                                    <tr>
                                                        <th>Annual Rent Received</th>
                                                        <th>Municipal Taxes</th>
                                                        <th>Net AnnualValue</th>
                                                        <th>Standard Deduction 30%</th>
                                                        <th>Repaying HomeLoan</th>
                                                        <th>Principal Paid OnHomeLoan</th>
                                                        <th>Interest Paid OnHomeLoan</th>
                                                        <th>Name Of TheLender</th>
                                                        <th>Lender PanNo</th>
                                                        <th>NetIncome/Loss</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    <tr *ngFor="let element of DetailData.Table5; let i = index">
                                                        <td class="text-end">{{element.AnnualRentReceived}}</td>
                                                        <td class="text-end">{{element.MunicipalTaxesPaid}}</td>
                                                        <td class="text-end">{{element.NetAnnualValue}}</td>
                                                        <td class="text-end">{{element.StandardDeduction}}</td>
                                                        <td>{{element.RepayingHomeLoanForThisProperty?'Yes':'No'}}</td>
                                                        <td class="text-end">{{element.PrincipalPaidOnHomeLoan}}</td>
                                                        <td class="text-end">{{element.InterestPaidOnHomeLoan}}</td>
                                                        <td>{{element.NameOfTheLender}}</td>
                                                        <td>{{element.LenderPanNo}}</td>
                                                        <td class="text-end">{{element.NetIncomeLossFromHouseProperty}}
                                                        </td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="card my-1">
                <div class="card-header">
                    <div class="row">
                        <div class="col">
                            <span class="custome-header">
                                <i class="bi bi-building px-2"></i>Other Sources of Income
                            </span>
                        </div>
                        <div class="col-auto mx-2 align-self-center" style="display: inline-flex;">
                            <span class="px-1"
                                style="font-size: 0.9rem;">{{this.OpenCard.CardEmpTaxDeclarationDetails_Others?'Yes':'No'}}</span>
                            <div class="form-check form-switch">
                                <input class="form-check-input" type="checkbox" role="switch"
                                    [checked]="OpenCard.CardEmpTaxDeclarationDetails_Others" id="flexSwitchCheckChecked"
                                    (change)="onSwitchChange($event,'CardEmpTaxDeclarationDetails_Others')">
                            </div>
                        </div>
                    </div>
                </div>
                <div>
                    <div #collapse="ngbCollapse" [(ngbCollapse)]="!OpenCard.CardEmpTaxDeclarationDetails_Others">
                        <div class="card-body">
                            <div class="card-body p-0 px-2">
                                <div class="row">
                                    <div class="col p-0">
                                        <div class="table-container">
                                            <table class="customeDatatable table table-bordered">
                                                <thead class="table-light">
                                                    <tr>
                                                        <th>SubSection Name</th>
                                                        <th>SubSection Description</th>
                                                        <th>Limit Applicable</th>
                                                        <th>MaxLimit Amount</th>
                                                        <th>Declared Amount</th>
                                                        <th>Approved Amount</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    <tr *ngFor="let element of DetailData.Table4; let i = index">
                                                        <td>{{element.SubSectionName}}</td>
                                                        <td>{{element.SubSectionDescription}}</td>
                                                        <td>{{DetailData.Table[0].IsNewRegime?element.IsNewMaxlimitapplicable:element.IsOldMaxlimitapplicable}}
                                                        </td>
                                                        <td class="text-end">
                                                            {{DetailData.Table[0].IsNewRegime?element.NewRegimeMaxAmount:element.OldRegimeMaxAmount}}
                                                        </td>
                                                        <td class="text-end">{{element.DeclaredAmount}}</td>
                                                        <td class="text-end">
                                                            {{common.ToLowerCase(DetailData.Table[0].ApprovalStatus) ==
                                                            'approved'?element.ApprovedAmount:''}}</td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="card-footer">
        <div class="row">
            <div class="col"></div>
            <div class="col-auto">
                <!-- <button type="button" class="btn btn-outline-info mx-1" [disabled]="isDisabled"
                    *ngIf="!this.Filter.IsDraft" (click)="Tracking()"><i
                        class="bi bi-person-lines-fill" *ngIf="!isDisabled"></i>
                    <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"
                        *ngIf="isDisabled"></span>
                    {{!isDisabled?'Tracking':'Loading...'}}</button> -->
                <button
                    *ngIf="(!this.Filter.IsDraft && this.user.UserType == 'A' && (this.DetailData.Table[0].ESS_EmpTaxInvestmentId == null || this.DetailData.Table[0].ESS_EmpTaxInvestmentId == 0))"
                    type="button" class="btn btn-outline-danger mx-1" [disabled]="isDisabled" (click)="Delete()"><i
                        class="bi bi-trash" *ngIf="!isDisabled"></i>
                    <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"
                        *ngIf="isDisabled"></span>
                    {{!isDisabled?'Delete':'Loading...'}}</button>

                <button type="button" class="btn btn-outline-primary mx-1" [disabled]="isDisabled" (click)="Cancel()"><i
                        class="bi bi-arrow-left" *ngIf="!isDisabled"></i>
                    <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"
                        *ngIf="isDisabled"></span>
                    {{!isDisabled?'Cancel':'Loading...'}}</button>

                <button type="button" class="btn btn-primary mx-1" [disabled]="isDisabled" (click)="GenerateTDSReport()"
                    *ngIf="!this.Filter.IsDraft && common.ToLowerCase(DetailData.Table[0].ApprovalStatus) == 'approved'"><i class="bi bi-file-earmark-arrow-down-fill" *ngIf="!isDisabled"></i>
                    <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"
                        *ngIf="isDisabled"></span>
                    {{!isDisabled?'TDS Report':'Loading...'}}</button>

                <button type="button" class="btn btn-primary mx-1" [disabled]="isDisabled"
                    [routerLink]="['/request/incometax/taxdeclaration/add/' + this.Filter.WebESSApprovalRequestTrackingId]"
                    *ngIf="(this.Filter.IsDraft) && this.common.PageRight.IsEdit"><i class="bi bi-chevron-right"
                        *ngIf="!isDisabled"></i>
                    <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"
                        *ngIf="isDisabled"></span>
                    {{!isDisabled?'Edit':'Loading...'}}</button>

                <button type="button" class="btn btn-primary mx-1" [disabled]="isDisabled"
                    [routerLink]="['/incometax/incometax/add/d/r/' + this.Filter.WebESSApprovalRequestTrackingId]"
                    *ngIf="!this.Filter.IsDraft && this.user.UserType == 'A' && this.common.PageRight.IsEdit"><i
                        class="bi bi-chevron-right" *ngIf="!isDisabled"></i>
                    <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"
                        *ngIf="isDisabled"></span>
                    {{!isDisabled?'Edit':'Loading...'}}</button>

                <button type="button" class="btn btn-success mx-1" [disabled]="isDisabled"
                    [routerLink]="['/incometax/compare/d/' + this.Filter.WebESSApprovalRequestTrackingId]"><i
                        class="bi bi-bookmark-check" *ngIf="!isDisabled"></i>
                    <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"
                        *ngIf="isDisabled"></span>
                    {{!isDisabled?'Compare':'Loading...'}}</button>
            </div>
        </div>
    </div>
</div>